import { API } from "@/services"
import { UPTIME_KUMA_CATEGORIES_ENDPOINTS } from "./categories"

export const UPTIME_KUMA_ENDPOINTS = {
  categories: UPTIME_KUMA_CATEGORIES_ENDPOINTS,
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma`,
      method: 'GET',
      params,
    })
  },
  chart(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/chart`,
      method: 'GET',
      params,
    })
  },
  dashboard(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/dashboard`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/${id}`,
      method: 'PUT',
      data,
    })
  },
}